<div class="ap canvas" role="main">
    <ap-panel type="secondary">
        <div ap-panel-body>
            <h1 class="secondary">{{ 'reason.header' | apContent }}</h1>
            <reason [reasonForm]="reasonFormGroup"></reason>
            @if (showNotificationSubject | async) {
                <cta></cta>
            } @else {
                <h2 class="secondary">{{ 'appointment.header.main' | apContent }}</h2>
                <personal-details [personalDetailsForm]="personalDetailsFormGroup"></personal-details>
                <ap-dutch-address data-bb="dutchAddressForm" [isRequired]="true" [addressForm]="addressFormGroup"></ap-dutch-address>
                <ap-contact-details data-bb="contactDetailsForm" [contactDetailsForm]="contactDetailsFormGroup"> </ap-contact-details>
                <other-subjects [otherSubjectsForm]="otherSubjectsFormGroup"></other-subjects>
                <ap-button data-bb="submitButton">
                    <ap-submit-text
                        (click)="onSubmit()"
                        (keydown)="onSubmit()"
                        [isLoading]="isLoading"
                        submitText="{{ 'submit.call_for_appointment' | apContent }}"
                        loadingText="{{ 'submit.loading' | apContent }}"
                    ></ap-submit-text>
                </ap-button>
            }
        </div>
    </ap-panel>
</div>
